import { cn } from '@/lib/utils';

/**
 * The BULK3.com identity, admin build.
 *
 * A deliberate copy of `website/src/components/brand/logo.tsx` rather than a
 * shared package — the three apps have no workspace between them (see the
 * decisions table in `docs/PHASES.md`), and the sidebar wants a smaller,
 * denser lockup than a storefront header does. The geometry is the same; if
 * the mark changes, both files and `website/scripts/generate-brand-assets.mjs`
 * change together.
 */

/** The mark alone: a shopping bag carrying a wrapped gift. */
export function BrandMark({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 32 32" className={cn('size-8', className)} aria-hidden="true">
      <path
        d="M11.3 11V7.2a4.7 4.7 0 0 1 9.4 0V11"
        fill="none"
        className="stroke-brand-600"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <rect x="3" y="10.2" width="26" height="18.8" rx="3.4" className="fill-brand-600" />
      <path
        d="M16 18.1c-1-2.7-2.6-4.6-4.3-4.4-1.7.2-2.1 2.4-.5 3.4 1.2.8 3.1 1.1 4.8 1Z"
        className="fill-accent-500"
      />
      <path
        d="M16 18.1c1-2.7 2.6-4.6 4.3-4.4 1.7.2 2.1 2.4.5 3.4-1.2.8-3.1 1.1-4.8 1Z"
        className="fill-accent-500"
      />
      <rect x="7.8" y="17.8" width="16.4" height="8.6" rx="1.2" className="fill-surface" />
      <rect x="14.2" y="17.8" width="3.6" height="8.6" className="fill-accent-500" />
    </svg>
  );
}

/**
 * The sidebar lockup.
 *
 * Labelled "Admin" beside the wordmark, because the two apps look alike enough
 * that an operator with both open needs the tab to say which is which.
 */
export function Logo() {
  return (
    <span className="flex items-center gap-2" aria-label="BULK3.com Admin">
      <BrandMark />
      <span className="text-base font-extrabold tracking-tight text-brand-600">
        BULK<span className="text-accent-600">3</span>
        <span className="text-[0.62em] font-bold tracking-normal">.com</span>
      </span>
      <span className="rounded bg-brand-50 px-1.5 py-0.5 text-[9px] font-bold uppercase tracking-wide text-brand-700">
        Admin
      </span>
    </span>
  );
}
